import styled from '@emotion/styled';
import { HEADER_HEIGHT } from 'ds/components/Layout';
import { DefaultText, H3, SmallText } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';

export const PageWrapper = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
    background-color: ${theme.colors.neutrals.grey11};
    padding: ${theme.spacing(5)};
    position: relative;
  `}
  min-height: calc(100vh - ${HEADER_HEIGHT}px);

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding-top: ${theme.spacing(3.5)};

    .pagination {
      margin-bottom: -${theme.spacing(1)};
    }

    .pagination > div {
      width: 100%;
      justify-content: space-between;
    }
  `}
`;

export const Header = styled(DefaultText)`
  display: flex;
  align-items: center;
  font-size: ${typographyFontSizeCfg.h2.mobile}px;
  line-height: ${typographyLineHeightCfg.h2.mobile}px;

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    font-size: ${typographyFontSizeCfg.h3.mobile}px;
    line-height: ${typographyLineHeightCfg.h3.mobile}px;
  `}
`;

export const Subheader = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;

Header.defaultProps = {
  weight: 'bold',
};

export const SubHeader = styled(H3)`
  white-space: nowrap;
`;
SubHeader.defaultProps = {
  weight: 'bold',
};

export const Collapse = styled.div<{ isCollapsed: boolean; }>`
  overflow: hidden;
  ${({ isCollapsed }) => isCollapsed ? `
    height: 0;
  ` : ''}
`;
